import React, { useState, useEffect } from "react";
import useStyled from "../../hooks/useStyled";
import { SFStack } from "../grid";
import SFGenericSearch from "../autoComplete/genericSearch";
import SFFilterChips from "../chip/filterChips";
import { useTranslation } from "react-i18next";

const { styled } = useStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
  width: "100%",
}));

const StyledDiv = styled("div")(({ theme }) => ({
  color: theme.palette.blue300.main,
  cursor: "pointer",
  padding: theme.spacing(1),
}));

const LoadindDiv = styled("div")(({ theme }) => ({
  color: theme.palette.grey350.main,
  padding: theme.spacing(1),
}));

const dataGridFilters = (props) => {
  const [filterValues, setFilterValues] = useState(null);
  const { t } = useTranslation();

  // Initialize the filter values for the autocomplete
  useEffect(() => {
    props.initializeFilter().then((res) => {
      setFilterValues(res.getFilterValues());
    });
  }, []);

  const onDelete = (filter) => {
    const newFilters = props.filters.filter((x) => x !== filter);
    props.handleFilterChange(newFilters);
  };

  return (
    <StyledStack alignItems="center" spacing={1}>
      {filterValues ? (
        <>
          <SFGenericSearch
            fullWidth
            onClose={(filters) => props.handleFilterChange(filters)}
            selectedValues={props.filters || []}
            source={
              filterValues?.map((option) => ({
                value: option,
              })) || []
            }
            placeholder={props.filterLabel}
            hasSearchIcon
            multiple
          />
          {props.filters?.length > 0 && (
            <SFFilterChips
              items={props.filters}
              variant="outlined"
              limit={5}
              customActions={
                <StyledDiv onClick={() => props.handleFilterChange([])}>
                  {t("components.datagrid.filters.clearAll")}
                </StyledDiv>
              }
              onDelete={onDelete}
            />
          )}
        </>
      ) : (
        <LoadindDiv>{t("components.datagrid.loadingMessage")}</LoadindDiv>
      )}
    </StyledStack>
  );
};

export default dataGridFilters;
